import { useTranslations } from "next-intl";
import { privateProps } from "@/features/analytics/lib/masking";
import { OrderNumberInline } from "../components/status/order-number-inline";
import type { OrderStatusProps } from "../types";
import type { Payment } from "../types/order-payment.type";

export const getStatusProps = ({
  status,
  orderRejected,
  displayId,
  email,
}: {
  status: Payment["status"];
  orderRejected?: boolean;
  displayId: string;
  email?: string;
}): OrderStatusProps => {
  const t = useTranslations("orderStatus");
  const imagePath = "/images/order-status/";

  const richValues = {
    orderId: () => <OrderNumberInline displayId={displayId} />,
    email: () => (
      <span className="font-medium text-brand-green1-300" {...privateProps}>
        {email}
      </span>
    ),
  };

  const descriptions = (key: string) => ({
    description1: t.rich(`statuses.${key}.description1`, richValues),
    description2: t.rich(`statuses.${key}.description2`, richValues),
  });

  if (orderRejected) {
    return {
      image: `${imagePath}rejected.svg`,
      title: t("statuses.rejected.title"),
      ...descriptions("rejected"),
    };
  }

  switch (status) {
    case "NEW":
    case "IN_PROGRESS":
      return {
        image: `${imagePath}pending.svg`,
        title: t("statuses.pending.title"),
        ...descriptions("pending"),
      };
    case "COMPLETED":
      return {
        image: `${imagePath}completed.svg`,
        title: t("statuses.completed.title"),
        ...descriptions("completed"),
      };
    case "CANCELED":
    case "REJECTED":
      return {
        image: `${imagePath}failed.svg`,
        title: t("statuses.canceled.title"),
        ...descriptions("canceled"),
      };
    default:
      return {
        title: t("statuses.unknown.title"),
        ...descriptions("unknown"),
      };
  }
};
